
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.805.483H2.195C1.25.483.484 1.25.484 2.196v27.608c0 .946.767 1.713 1.713 1.713h14.863V19.5h-4.044v-4.684h4.044v-3.454c0-4.008 2.449-6.19 6.024-6.19 1.713 0 3.185.127 3.615.184v4.189h-2.48c-1.945 0-2.322.925-2.322 2.281v2.99h4.638L25.93 19.5h-4.034v12.018h7.909c.945 0 1.712-.767 1.712-1.713V2.196c0-.946-.767-1.713-1.712-1.713z","fill":"#fff"}})])
          )
        }
      }
    